import styled from 'styled-components'

export const SocialWrapper = styled.div`
  & .social-media-text {
    cursor: pointer;
  }
`
